<template>
    <button
        v-if="state"
        @click="onRefine"
        class="AlgoliaSearchClear flex-center"
        :class="{ 'is-active': !state.hasRefinements }"
    >
        <slot/>
    </button>
</template>
<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectClearRefinements } from 'instantsearch.js/es/connectors'

export default {
    name: 'AlgoliaSearchClear',
    props: {
        includedAttributes: {
            type: String,
            default: undefined
        },
        excludedAttributes: {
            type: Array,
            default: undefined
        }
    },
    mixins: [
        createWidgetMixin({ connector: connectClearRefinements })
    ],

    computed: {
        widgetParams() {
            return {
                includedAttributes: this.includedAttributes ? [this.includedAttributes] : undefined,
                excludedAttributes: this.excludedAttributes ? [this.excludedAttributes] : undefined
            };
        }
    },

    methods: {
        onRefine() {
            this.state.refine();
            setTimeout(() => {
                this.$emit('resetLocations');
            }, 550);

        }
    }
}
</script>
